import { render } from "./PictureCompression.vue?vue&type=template&id=5c4b0578&scoped=true"
import script from "./PictureCompression.vue?vue&type=script&lang=js"
export * from "./PictureCompression.vue?vue&type=script&lang=js"

import "./PictureCompression.vue?vue&type=style&index=0&id=5c4b0578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4b0578"]])

export default __exports__